module.exports = __webpack_public_path__ + "static/img/qr_stand_bg.74871e72.png";